import wv from '@cpc/lib-browser-jsapi';
import { $$, $ } from '@js/utils';
import imgReady from '@js/imgready';
// import * as event from 'js/event'

export function domReadyHandler() {
  // if (window.store.pageType === 'document') {
  //   // 中台返回的contentPicList图片数量
  //   const imgList = window.store.pics
  //   const picLen = imgList.length
  //   // 获取正文返回的正文图片数量
  //   const imgDom = $$('.entry-content .content-image')
  //   const imgLen = imgDom.length
  //   if (picLen > 0 && picLen == imgLen) {
  //     // 先处理暗色模式默认图片替换
  //     replaceNightImg(imgDom, imgLen)
  //     // 加载真实的文章图片
  //     lazyLoad(imgList, imgDom, imgLen)
  //   }
  // }
  // event.bindEvent('click')
  // event.addHandler({
  //   showOriginalImage: function (node) {
  //     // 通知客户端用户要查看大图，该方法在V5.1以下版本中不存在
  //     wv &&
  //       wv.confirmAllowLoadHdImageInSaveMode &&
  //       wv.confirmAllowLoadHdImageInSaveMode()
  //     let allPics = $$('.a-image__image-wrap')
  //     allPics.forEach((item, index) => {
  //       const imgItem = item.firstChild
  //       imgItem.src = window.store.pics[index].url
  //       imgItem.parentNode.classList.remove('thumbnail')
  //     })
  //     $('.view-original-image').style['display'] = 'none'
  //   },
  // })
}

export function reportReadingProgress() {
  const { pageType } = window.store;
  //不需阅读进度控制
  if (['gallery', 'comment', 'second-comment', 'taobao'].includes(pageType)) {
    return;
  }
  const titleHeight = $('h1.document__title')
    ? $('h1.document__title').offsetHeight
    : $('h1.document__title-simple').offsetHeight; // 标题高度
  const headerHeight = $('header.document-media')
    ? $('header.document-media').offsetHeight
    : $('.document-media__author__box-simple').offsetHeight; // header(作者日期)高度
  const articleHeight = $('section.article').offsetHeight; // 文章高度
  const articleTotalHeight = titleHeight + headerHeight + articleHeight; // 文章总高度
  const screenHeight = window.screen.height; // 浏览器可视区域的高度
  let readingHeight = screenHeight; // 阅读高度，默认等于屏幕可视区域高度
  var readingProgress = parseInt((readingHeight / articleTotalHeight) * 100); // 默认第一屏就有阅读进度
  let maxReadingProgress = Math.min(readingProgress, 100);
  localStorage.setItem('readingProgress', readingProgress);

  window.addEventListener('scroll', function (e) {
    const target = e.srcElement || e.target;
    let articleScrollTop = target.scrollingElement.scrollTop; // 文章滚出屏幕的高度
    readingHeight = screenHeight + articleScrollTop;
    if (readingHeight >= articleTotalHeight) {
      readingHeight = articleTotalHeight;
    }
    readingProgress = parseInt((readingHeight / articleTotalHeight) * 100);
    if (readingProgress > maxReadingProgress) {
      maxReadingProgress = readingProgress; // 防止往回滑，阅读进度减少
    }
    localStorage.setItem('readingProgress', maxReadingProgress);
  });

  if (window.BrowserIFlow) {
    wv.initDocProgressReadCallback &&
      wv.initDocProgressReadCallback(function () {
        return parseInt(localStorage.getItem('readingProgress'));
      });
  }

  if (window.pageData?.isCommonSdk) {
    window.OppoFeeds.getIFlowStayModelParam = () => {
      const readingProgress = parseInt(localStorage.getItem('readingProgress'));
      if (readingProgress > 100) {
        return 100;
      }
      return readingProgress;
    };
  }
}

// 暗色模式下替换默认占位图片，暂时弃用
export function replaceNightImg(imgList, imgDom, picLen, imgLen) {
  window.document.addEventListener('nightmodechange', function () {
    const isNightMode = window.getNightmode();
    //日间模式占位图
    const dayImg =
      'data:image/jpgbase64,/9j/4AAQSkZJRgABAQAAAQABAAD/2wBDAAMCAgICAgMCAgIDAwMDBAYEBAQEBAgGBgUGCQgKCgkICQkKDA8MCgsOCwkJDRENDg8QEBEQCgwSExIQEw8QEBD/wAALCABkAMgBAREA/8QAFQABAQAAAAAAAAAAAAAAAAAAAAn/xAAUEAEAAAAAAAAAAAAAAAAAAAAA/9oACAEBAAA/AKZgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/9k=';
    // 日间模式占位图
    const nightImg =
      'data:image/jpgbase64,/9j/4AAQSkZJRgABAQAAAQABAAD/2wBDAAMCAgICAgMCAgIDAwMDBAYEBAQEBAgGBgUGCQgKCgkICQkKDA8MCgsOCwkJDRENDg8QEBEQCgwSExIQEw8QEBD/wAALCABkAMgBAREA/8QAFQABAQAAAAAAAAAAAAAAAAAAAAn/xAAUEAEAAAAAAAAAAAAAAAAAAAAA/9oACAEBAAA/AKpgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP/9k=';
    for (let i = 0; i < imgLen; i++) {
      imgDom[i].src = isNightMode ? nightImg : dayImg;
    }
  });
}

// 真实图片覆盖默认占位图，暂时弃用
export function lazyLoad(imgList, imgDom, imgLen) {
  for (let i = 0; i < imgLen; i++) {
    const loadUrl = imgList[i].picUrl || imgList[i].url;
    imgReady(
      loadUrl,
      function () {
        imgDom[i].src = loadUrl;
      },
      function () {},
      function (error) {
        console.error(error);
      },
    );
  }
}

// 处理资讯省流模式，暂时弃用
// export function lazyLoad() {
//   if (window.store.pics.length === 0) return
//   const wraps = $$('.entry-content .a-image__image-wrap')
//   const len = wraps.length
//   const isWifi = window.navigator.connection.type === 'wifi'
//   const isSaveModeOpen = wv && wv.isSaveModeOpen && wv.isSaveModeOpen()
//   const isSaveMode = (isSaveModeOpen && isSaveModeOpen.data) || false
//   //是否点击过查看原图按钮
//   const isAllowLoadHdImageInSaveMode =
//     wv && wv.isAllowLoadHdImageInSaveMode && wv.isAllowLoadHdImageInSaveMode()
//   const isClickedBtn =
//     (isAllowLoadHdImageInSaveMode && isAllowLoadHdImageInSaveMode.data) ||
//     false
//   // 是否显示高清图
//   const hdImageShow = isWifi || (isSaveMode && isClickedBtn) || !isSaveMode
//   const viewBtn = $('.view-original-image')
//   if (viewBtn) {
//     if (hdImageShow && len > 0) {
//       viewBtn.style['display'] = 'none'
//     } else {
//       viewBtn.style['display'] = 'block'
//     }
//   }
//   for (let i = 0; i < len; i++) {
//     const pic = window.store.pics[i]
//     const wrap = wraps[i]
//     const loadUrl = hdImageShow ? pic.url : pic.picUrl
//     debugger
//     imgReady(
//       loadUrl,
//       function () {
//         let img = document.createElement('img')
//         img.src = loadUrl
//         wrap.appendChild(img)
//         if (!hdImageShow) {
//           img.parentNode.classList.add('thumbnail')
//         }
//       },
//       function () {
//       },
//       function (error) {
//         console.error(error)
//       },
//     )
//   }
// }

// 上报停留时长
export function getSubjectActivityInfo() {
  const { activity_id, bs_entry } = window.store;
  if (activity_id && bs_entry) {
    let obj = {
      activity_id,
      bs_entry,
    };
    window.wv.getSubjectActivityInfo(obj);
  }
}

//通知客户端更新数字图标，跳转url等信息
export function pubArticleInfo() {
  const { docId, resourceId, commentCount, commentMoreUrl } = window.store;
  const data = {
    outId: docId,
    docid: resourceId,
    comment_count: commentCount,
    comment_more_url: commentMoreUrl,
  };
  window.wv.getArticleInfo([data]);
}
